import * as React from 'react'

export const applyBlock = () => {
  return (
    <section className="block block--apply apply">
      <div className="block__inner container container--m grid--block">
        <div className="block__content">
          <h2 className="apply__title title--l">Apply now</h2>
          <div className="apply__message">
            <p>
              Apply directly by filling out our application form, or contact our recruiter if you have any questions about the vacancy or the recruitment process.
            </p>
          </div>
          <div className="apply__buttons">
            <a href="/" className="button button--primary">Apply now</a>
            <a
              className="button button--secondary"
              href={`mailto:info@viddadigital.com`} >
              Contact recruiter
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
